<template>
  <div class="openid-get">
    <vue-qr :text="url" :margin="0" :size="size"></vue-qr>
  </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'openid-get',

  components: { VueQr },

  data() {
    return {
      size: 200
    }
  },

  computed: {
    url() {
      let redirect_uri = encodeURI(
        `${this.$web_url}look-openid`
      )
      return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`
    }
  }
}
</script>

<style scoped lang="less">
</style>
